
export default class GoogleMap
{
    constructor(root, options) {
        this.markers = [];

        options.center.lat = parseFloat(options.center.lat);
        options.center.lng = parseFloat(options.center.lng);

        this.map = new google.maps.Map(root, options);
    }

    addMarker(options) {
        options.map = this.map;

        this.markers.push(
            new google.maps.Marker(options)
        );
    }
}
